import React, {useContext, useEffect} from 'react';
import PropTypes from 'prop-types';
import { at } from 'lodash';
import { useField } from 'formik';
import {TEXT_NONE_OF_THE_ABOVE} from '../common/DataTypes';
import {
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  Radio
} from '@mui/material';
import { EligibilityContext } from '../common/EligibilityContext';
import useStyles from './styles';

function SelectMultipleField(props) {
  const classes = useStyles();
  const {eligibilityResult} = useContext(EligibilityContext);
  const [selectItem, setSelectItem] = React.useState([]);


  const { label, data, ...rest} = props;
  const [field, meta, includeNone] = useField(props);
  const { value: selectedValue } = field;
  const [touched, error] = at(meta, 'touched', 'error');
  const isError = touched && error && true;
  //const data2 = includeNone === true ? data : data.filter((item)=>item.indexOf(TEXT_NONE_OF_THE_ABOVE) == -1);
  //const data3 = data2 && data2.map(item=>{ return {label:item, value:item}});
  const data3 = data && data.map(item=>{ return {label:item, value:item}});
  function _renderHelperText() {
    if (isError) {
      return <FormHelperText>{error}</FormHelperText>;
    }
  }

  const handleChange = (event) => {
    let selectedValue = event.target.value;
    if(selectedValue.indexOf(TEXT_NONE_OF_THE_ABOVE) > -1) {
      if(field.value.indexOf(TEXT_NONE_OF_THE_ABOVE) > -1) {
        event.target.value = selectedValue.filter((item)=>item.indexOf(TEXT_NONE_OF_THE_ABOVE) < 0);
      } else {
        event.target.value = selectedValue.filter((item)=>item.indexOf(TEXT_NONE_OF_THE_ABOVE) > -1);
      }

      field.onChange(event);
    } else {
      field.onChange(event);
    }
  };

  return (
    <FormControl {...rest} error={isError} className={classes.multiSelect}>
      <InputLabel>{label}</InputLabel>
      <Select {...field} value={selectedValue ? selectedValue : ''}
       onChange={handleChange}>
        {data3.map((item, index) => (
          <MenuItem key={index} value={item.value} style={{fontSize:14}}>
            <Radio checked={item.value == selectedValue} />
            {item.label}
          </MenuItem>
        ))}
      </Select>
      {_renderHelperText()}
    </FormControl>
  );
}

SelectMultipleField.defaultProps = {
  data: []
};

SelectMultipleField.propTypes = {
  data: PropTypes.array.isRequired
};

export default SelectMultipleField;
